module.exports = __webpack_public_path__ + "img/course109_curriculum.10e5fe3c.png";